export enum SliderTitles {
  LEARN_MORE = 'Дізнатися більше',
  LANDSCAPES_BTN = 'Захоплюючі пейзажі Каталонії',
  CATALUNYA = 'Каталонія',
}
